import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import AlterarComercialProcesso from './AlterarComercialProcesso';

function AlterarComercialProcessoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Alterar Comercial Processo'));
  return (
    <AlterarComercialProcesso />
  );
}

export default withTokenInterceptor(AlterarComercialProcessoPage);
